module.exports = __webpack_public_path__ + "img/PAX.2aab32b3.svg";